module.exports = __webpack_public_path__ + "static/media/management.6a1d499a.jpg";